// extracted by mini-css-extract-plugin
export default {"melodyVideo":"ZM-z","isFullWidth":"_M-z","landingPageVideo":"aN-z","play":"bN-z","iframeVideo":"cN-z","playHidden":"dN-z","fullwidth":"eN-z"};